import { motion } from "framer-motion";
import { Check, X, Crown, Star } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const rows = [
  { label: "Harga Awal", gemini: { text: "Sangat Terjangkau", short: "Terjangkau", star: true }, gpt: "Lebih Mahal", claude: "Lebih Mahal" },
  { label: "Masa Aktif", gemini: { text: "18 Bulan" }, gpt: "Berlangganan Bulanan", gptShort: "Bulanan", claude: "Berlangganan Bulanan", claudeShort: "Bulanan" },
  { label: "Google Workspace", gemini: { check: true, text: "Terintegrasi" }, gpt: false, claude: false, xLabel: "Tidak Terintegrasi" },
  { label: "Google Drive", gemini: { check: true }, gpt: false, claude: false },
  { label: "Gmail AI", gemini: { check: true }, gpt: false, claude: false },
  { label: "Docs AI", gemini: { check: true }, gpt: false, claude: false },
  { label: "Sheets AI", gemini: { check: true }, gpt: false, claude: false },
  { label: "NotebookLM", gemini: { check: true }, gpt: false, claude: false },
  { label: "Flow AI Video", gemini: { check: true }, gpt: false, claude: false },
  { label: "Cloud Storage", gemini: { text: "5TB" }, gpt: "Tidak termasuk", gptShort: "Tidak ada", claude: "Tidak termasuk", claudeShort: "Tidak ada" },
];

const GeminiCell = ({ v }) => (
  <div className="flex items-center justify-center gap-1 md:gap-1.5 font-bold text-blue-700">
    {v.star && <Star className="w-3 h-3 md:w-4 md:h-4 fill-amber-400 text-amber-400 shrink-0" />}
    {v.check && <Check className="w-4 h-4 md:w-5 md:h-5 text-emerald-600 shrink-0" strokeWidth={3} />}
    {v.text && (
      <span className="text-[11px] md:text-sm leading-tight">
        {v.short ? (
          <>
            <span className="md:hidden">{v.short}</span>
            <span className="hidden md:inline">{v.text}</span>
          </>
        ) : (
          v.text
        )}
      </span>
    )}
  </div>
);

const OtherCell = ({ v, short, xLabel }) =>
  v === false ? (
    <div className="flex items-center justify-center gap-1.5 text-slate-400">
      <X className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" strokeWidth={2.5} />
      {xLabel && <span className="text-xs hidden md:inline">{xLabel}</span>}
    </div>
  ) : (
    <span className="text-[11px] md:text-sm text-slate-500 leading-tight">
      {short ? (
        <>
          <span className="md:hidden">{short}</span>
          <span className="hidden md:inline">{v}</span>
        </>
      ) : (
        v
      )}
    </span>
  );

export const Comparison = () => (
  <section className="py-20 md:py-28 bg-slate-50" id="perbandingan">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <SectionHeader
        title="Kenapa lebih untung memilih Gemini Pro?"
        sub="Perbandingan objektif manfaat paket — bukan sekadar chatbot, tapi seluruh ekosistem produktivitas."
      />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="rounded-2xl md:rounded-3xl border border-slate-200 bg-white shadow-[0_8px_40px_rgba(0,0,0,0.05)] overflow-hidden"
        data-testid="comparison-table"
      >
        <table className="w-full text-left table-fixed md:table-auto">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="w-[27%] md:w-auto p-2.5 md:p-5 text-[10px] md:text-sm font-bold text-slate-500 uppercase tracking-wider">Fitur</th>
              <th className="w-[29%] md:w-auto p-2 md:p-5 text-center bg-blue-50/70 border-x-2 border-blue-200">
                <div className="flex flex-col items-center gap-1">
                  <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-[8px] md:text-[10px] font-extrabold px-2 md:px-2.5 py-0.5 md:py-1 uppercase tracking-wide">
                    <Crown className="w-2.5 h-2.5 md:w-3 md:h-3" /> Terbaik
                  </span>
                  <span className="font-heading font-extrabold text-slate-900 text-[11px] md:text-base leading-tight">
                    <span className="md:hidden">Gemini Pro</span>
                    <span className="hidden md:inline">Gemini Pro 18 Bulan</span>
                  </span>
                  <span className="text-[10px] md:text-xs font-bold text-blue-600">Rp79rb</span>
                </div>
              </th>
              <th className="p-2 md:p-5 text-center font-heading font-bold text-slate-600 text-[11px] md:text-base">ChatGPT</th>
              <th className="p-2 md:p-5 text-center font-heading font-bold text-slate-600 text-[11px] md:text-base">Claude</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.label} className={i % 2 ? "bg-slate-50/50" : ""}>
                <td className="p-2.5 md:p-5 font-semibold text-slate-800 text-[11px] md:text-sm leading-tight">{row.label}</td>
                <td className="p-2 md:p-5 text-center bg-blue-50/70 border-x-2 border-blue-200">
                  <GeminiCell v={row.gemini} />
                </td>
                <td className="p-2 md:p-5 text-center">
                  <OtherCell v={row.gpt} short={row.gptShort} xLabel={row.xLabel} />
                </td>
                <td className="p-2 md:p-5 text-center">
                  <OtherCell v={row.claude} short={row.claudeShort} xLabel={row.xLabel} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
      <p className="mt-5 text-xs text-slate-400 leading-relaxed max-w-3xl">
        Perbandingan ini ditujukan untuk membantu memahami perbedaan manfaat paket dan ekosistem yang disertakan. Fitur dapat berubah
        mengikuti kebijakan masing-masing penyedia.
      </p>
    </div>
  </section>
);
